import "@/App.css";
import { LanguageProvider } from "./context/LanguageContext";
import { Navbar } from "./components/layout/Navbar";
import { Hero } from "./components/sections/Hero";
import { Services } from "./components/sections/Services";
import { Portfolio } from "./components/sections/Portfolio";
import { About } from "./components/sections/About";
import { Contact } from "./components/sections/Contact";
import { QuoteForm } from "./components/sections/QuoteForm";
import { Footer } from "./components/layout/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="App font-inter" data-testid="app-root">
        <Navbar />
        <main>
          <Hero />
          <Services />
          <Portfolio />
          <About />
          <Contact />
          <QuoteForm />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
